<template>
  <div>
    <v-app-bar flat color="transparent" class="main-appbar">
      <app-bar-nav-icon />
      <v-skeleton-loader
        type="chip"
        transition="fade-transition"
        v-if="loading"
      ></v-skeleton-loader>

      <v-toolbar-title v-else class="headline font-weight-bold"
        >Exercises ({{ listMeta.total }})</v-toolbar-title
      >

      <v-spacer></v-spacer>

      <v-btn color="primary" class="mb-2" @click="addExerciseDialog = true">
        <v-icon left> {{ icons.add }} </v-icon>Add Exercise
      </v-btn>
    </v-app-bar>

    <div class="mt-12 mb-6">
      <v-row>
        <v-col cols="12" md="3">
          <v-text-field
            outlined
            clearable
            hide-details
            label="Search"
            @input="doFilter"
            placeholder="Search by Name"
            v-model="search"
          ></v-text-field>
        </v-col>
      </v-row>
    </div>

    <v-data-table
      :items="exercises"
      :loading="loading"
      :headers="headers"
      class="elevation-1"
      :options.sync="options"
      :server-items-length="listMeta.total"
      :footer-props="{ 'items-per-page-options': [10, 20, 50, 100] }"
    >
      <template v-slot:top="{ pagination, options, updateOptions }">
        <v-data-footer
          :pagination="pagination"
          :options="options"
          @update:options="updateOptions"
          items-per-page-text="$vuetify.dataTable.itemsPerPageText"
          :items-per-page-options="[10, 20, 50, 100]"
        />
      </template>
      <template v-slot:[`item.image`]="{ item }">
        <v-avatar tile>
          <img :src="thumbnailSrc(item.image)" />
        </v-avatar>
      </template>
      <template v-slot:[`item.name`]="{ item }">
        {{ item.name }}
      </template>
      <template v-slot:[`item.steps.length`]="{ item }">
        {{ item.steps.length }}
      </template>
      <template v-slot:[`item.total_duration`]="{ item }">
        {{ item.total_duration }}
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <v-chip class="text-capitalize" :color="getColor(item.status)" dark>
          {{ getStatus(item.status) }}
        </v-chip>
      </template>
      <template v-slot:[`item.created_at`]="{ item }">
        {{ item.addedDate }}
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn
          small
          block
          depressed
          @click="
            $router.push({ name: 'exercises.details', params: { id: item.id } })
          "
        >
          Edit
        </v-btn>
      </template>
    </v-data-table>

    <AddExerciseDialog v-model="addExerciseDialog"></AddExerciseDialog>
  </div>
</template>

<script>
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import ControlsMixin from '@/utils/mixins/Controls'
import { mdiPlus } from '@mdi/js'
import { mapState, mapActions, mapMutations } from 'vuex'
import debounce from 'lodash/debounce'
import AddExerciseDialog from './components/AddExerciseDialog.vue'

export default {
  name: 'ExercisesPage',
  mixins: [ControlsMixin],
  components: {
    AppBarNavIcon,
    AddExerciseDialog
  },
  data() {
    return {
      icons: {
        add: mdiPlus
      },
      addExerciseDialog: false,
      loading: false,
      options: {},
      headers: [
        {
          text: 'Thumbnail',
          sortable: false,
          value: 'image',
          width: '150px',
          align: 'center'
        },
        {
          text: 'Name',
          sortable: true,
          value: 'name'
        },
        {
          text: 'No. of steps',
          sortable: false,
          value: 'steps.length',
          align: 'center',
          width: '150px'
        },
        {
          text: 'Total Duration',
          align: 'center',
          sortable: false,
          value: 'total_duration',
          width: '250px'
        },
        {
          text: 'Status',
          align: 'center',
          sortable: true,
          value: 'status',
          width: '100px'
        },
        {
          text: 'Date Created',
          sortable: true,
          value: 'created_at',
          width: '250px'
        },
        {
          text: 'Actions',
          align: 'center',
          sortable: false,
          value: 'actions',
          width: '150px'
        }
      ],
      search: null
    }
  },
  computed: {
    ...mapState({
      exercises: state => state.exercise.list,
      listMeta: state => state.exercise.listMeta
    })
  },
  methods: {
    ...mapActions({
      getExercises: 'exercise/getExercises'
    }),

    ...mapMutations({
      clearExercises: 'exercise/clearExerciseList'
    }),

    async getDataFromApi() {
      this.loading = true
      this.clearExercises()
      await this.getExercises({
        search: this.search,
        ...this.options
      })
      this.loading = false
    },

    doFilter: debounce(function() {
      this.getDataFromApi()
    }, 600),

    thumbnailSrc(image) {
      return image
        ? image.thumb_url
        : require('@/assets/images/default-image.jpeg')
    },

    getColor(status) {
      if (!status) return 'red'

      return 'green'
    },

    getStatus(status) {
      if (!status) return 'Disabled'

      return 'Active'
    }
  },
  watch: {
    options: {
      handler() {
        this.getDataFromApi()
      },
      deep: true
    }
  }
}
</script>
